import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";
//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Home
const GQLAddhomeFilter = gql`
  mutation addHomeFilter(
    $userid: String
    $minprice: Float
    $maxprice: Float
    $minbeds: Float
    $maxbeds: Float
    $minbaths: Float
    $maxbaths: Float
    $propertytype: String
    $is_sale: Int
    $is_pending: Int
    $is_sold: Int
    $is_rent: Int
    $minsqft: Float
    $maxsqft: Float
    $minlotsize: Float
    $maxlotsize: Float
    $minyear: Float
    $maxyear: Float
    $maxhoafees: Float
    $solddate: Int
  ) {
    addHomeFilter(
      userid: $userid
      minprice: $minprice
      maxprice: $maxprice
      minbeds: $minbeds
      maxbeds: $maxbeds
      minbaths: $minbaths
      maxbaths: $maxbaths
      propertytype: $propertytype
      is_sale: $is_sale
      is_pending: $is_pending
      is_sold: $is_sold
      is_rent: $is_rent
      minsqft: $minsqft
      maxsqft: $maxsqft
      minlotsize: $minlotsize
      maxlotsize: $maxlotsize
      minyear: $minyear
      maxyear: $maxyear
      maxhoafees: $maxhoafees
      solddate: $solddate
    ) {
      success
      message
    }
  }
`;

const QUERY_GetHomeFilter = gql`
  query gethomefilter(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    gethomefilter(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      userid
      minprice
      maxprice
      minbeds
      maxbeds
      minbaths
      maxbaths
      propertytype
      is_sale
      is_pending
      is_sold
      is_rent
      minsqft
      maxsqft
      minlotsize
      maxlotsize
      minyear
      maxyear
      maxhoafees
      solddate
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Home Filter Function

async function addHomeFilter(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddhomeFilter,

        variables: {
          userid: adddata.userid,
          minprice: adddata.minprice,
          maxprice: adddata.maxprice,
          minbeds: adddata.minbeds,
          maxbeds: adddata.maxbeds,
          minbaths: adddata.minbaths,
          maxbaths: adddata.maxbaths,
          propertytype: adddata.propertytype,
          is_sale: adddata.is_sale,
          is_pending: adddata.is_pending,
          is_sold: adddata.is_sold,
          is_rent: adddata.is_rent,
          minsqft: adddata.minsqft,
          maxsqft: adddata.maxsqft,
          minlotsize: adddata.minlotsize,
          maxlotsize: adddata.maxlotsize,
          minyear: adddata.minyear,
          maxyear: adddata.maxyear,
          maxhoafees: adddata.maxhoafees,
          solddate: adddata.solddate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Get Home Filter function
async function gethomefilter(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_GetHomeFilter,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { addHomeFilter, gethomefilter };
